import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
/**
 * Lightbox opened from PaintingsPage - shows one aquarelle full-size with
 * previous/next navigation through the whole loaded set (wraps at both
 * ends, arrow keys work too). Same interaction as champis-species' own
 * SpeciesGalleryModal - this is a paintings-scoped copy rather than a
 * shared import, since Flarum extensions don't have a mechanism for
 * importing each other's uncompiled JS source, and reusing class names
 * across extensions would bleed one's CSS into the other's DOM.
 */
export default class PaintingsGalleryModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);
    this.index = this.attrs.index;
  }
  oncreate(vnode) {
    super.oncreate(vnode);
    this.onkeydown = this.onkeydown.bind(this);
    document.addEventListener('keydown', this.onkeydown);
  }
  onremove(vnode) {
    super.onremove(vnode);
    document.removeEventListener('keydown', this.onkeydown);
  }
  onkeydown(e) {
    if (e.key === 'ArrowLeft') this.previous();
    if (e.key === 'ArrowRight') this.next();
  }
  className() {
    return 'Modal--large PaintingsGalleryModal';
  }

  // Species name (+ vernacular name when there is one) rather than
  // SpeciesGalleryModal's "by {username}" - what's being shown matters
  // more here than who posted it, and the list this modal is opened from
  // doesn't show authors either (see PaintingsPage.js).
  title() {
    const photo = this.attrs.photos[this.index];
    if (!photo.canonicalName) return photo.baseName;
    return photo.vernacularName ? `${photo.canonicalName} — ${photo.vernacularName}` : photo.canonicalName;
  }
  content() {
    const photos = this.attrs.photos;
    const photo = photos[this.index];
    return m("div", {
      className: "Modal-body PaintingsGalleryModal-body"
    }, m(Button, {
      icon: "fas fa-chevron-left",
      className: "Button Button--icon PaintingsGalleryModal-nav PaintingsGalleryModal-nav--prev",
      onclick: () => this.previous(),
      disabled: photos.length < 2,
      "aria-label": app.translator.trans('champis-paintings.forum.gallery.previous')
    }), m("div", {
      className: "PaintingsGalleryModal-image"
    }, m("img", {
      src: photo.url,
      alt: photo.baseName
    })), m(Button, {
      icon: "fas fa-chevron-right",
      className: "Button Button--icon PaintingsGalleryModal-nav PaintingsGalleryModal-nav--next",
      onclick: () => this.next(),
      disabled: photos.length < 2,
      "aria-label": app.translator.trans('champis-paintings.forum.gallery.next')
    }), m("div", {
      className: "PaintingsGalleryModal-footer"
    }, photo.caption && m("div", {
      className: "PaintingsGalleryModal-caption"
    }, photo.caption), m("div", {
      className: "PaintingsGalleryModal-meta"
    }, m("span", {
      className: "PaintingsGalleryModal-count"
    }, this.index + 1, " / ", photos.length), photo.discussionId && m("a", {
      href: app.route('discussion', {
        id: photo.discussionId
      })
    }, app.translator.trans('champis-paintings.forum.gallery.source')))));
  }
  previous() {
    const count = this.attrs.photos.length;
    this.index = (this.index - 1 + count) % count;
    m.redraw();
  }
  next() {
    const count = this.attrs.photos.length;
    this.index = (this.index + 1) % count;
    m.redraw();
  }
}
flarum.reg.add('champis-paintings', 'forum/components/PaintingsGalleryModal', PaintingsGalleryModal);